import * as LLog from '@utils/llogWrapper';
import { createBridgeClient } from '@services/messageHub/bridge';

const messageHandlers: { [key: string]: Array<(...args: any) => any> } = {};

function postMessageToParent(method: string, args?: any) {
    const message = JSON.stringify({
        method,
        args: Array.prototype.slice.call(args || []),
    });

    parent.postMessage(message, '*');

    LLog.info(message, LLog.REPORT_TAG_TYPE.POST_MESSAGE);
}

/**
 * im 页面里的子页面专用跳转逻辑，waimaie 的格式是：{method, args}，im 的格式是：{type, data}，所以有两套
 * @param type 消息类型
 * @param data 消息参数
 */
function postMessageToImParent(type: string, data?: any) {
    const message = JSON.stringify({
        type,
        data,
    });

    parent.postMessage(message, '*');

    LLog.info(message, LLog.REPORT_TAG_TYPE.POST_MESSAGE);
}

interface IJumpToParams {
    // 要跳转的地址
    href: string;
    // 需要强制选中的左侧菜单的文案
    selectLabel?: string;
}

const bridgeApp = {
    /**
     * 唤起主页面协议签署弹框
     *
     * @param options 参数对象
     */
    signContract(options: { url: string; noAutoReloadAfterSign?: boolean }) {
        postMessageToParent('signContract', [options]);
    },
    /**
     * 完成协议签署（关闭签署弹框）
     */
    finishSignContract() {
        postMessageToParent('finishSignContract');
    },
    /**
     * 通知外层页面切换 iframe 的地址，会走 waimaie 统一的逻辑在URL中补充必要的参数
     */
    jumpTo(params: IJumpToParams) {
        postMessageToParent('jumpTo', [params]);
    },
    /**
     * 通知外层页面后退（相当于点击浏览器后退按钮）
     */
    goBack() {
        postMessageToParent('goBack');
    },
    /**
     * IM子页面使用：通知外层页面(即IM主页面)关闭弹窗
     */
    closeDialog(params: any) {
        postMessageToImParent('closeDialog', params);
    },
    /**
     * IM子页面使用：通知外层页面(即IM主页面)当前选择的商品
     */
    selectProduct(params: any) {
        postMessageToImParent('selectProduct', params);
    },
    /**
     * 添加一个消息回调
     *
     * @param messageType 消息类型
     * @param handler 回调函数
     */
    addMessageHandler(messageType: string, handler: (...args: any) => any) {
        if (!messageHandlers[messageType]) {
            messageHandlers[messageType] = [];
        }

        messageHandlers[messageType].push(handler);
    },
    /**
     * 移除一个消息回调
     *
     * @param messageType 消息类型
     * @param handler 回调函数
     */
    removeMessageHandler(messageType: string, handler?: (...args: any) => any) {
        if (!handler) {
            messageHandlers[messageType] = [];
        } else if (messageHandlers[messageType] && handler) {
            messageHandlers[messageType] = messageHandlers[messageType].filter(h => h !== handler);
        }
    },
    /** 从外层获取待处理订单计数 */
    getOrderCount() {
        postMessageToParent('getOrderCountFromParent');
    },
    /** 清空外层主页面的未读站内信计数 */
    clearUnReadNotificationCount() {
        postMessageToParent('clearUnReadNotificationCount');
    },
    /** 上报iframe内层页面静态资源版本号 */
    reportIframeFeVersion(iframeFeVersion: string) {
        postMessageToParent('checkFeVersionRefresh', [iframeFeVersion]);
    },
    logout() {
        postMessageToParent('logon');
    },
    messageHub: createBridgeClient(postMessageToParent),
};

window.addEventListener('message', function(event) {
    let messageData;
    try {
        messageData = JSON.parse(event.data) as { type: string; data: any };
        const handlers = messageHandlers[messageData.type];
        if (handlers && handlers.length > 0) {
            for (let i = 0; i < handlers.length; i++) {
                const result = !!handlers[i].call(null, messageData.data);
                // 返回值为false则不继续往下执行
                if (result === false) {
                    break;
                }
            }
        }
    } catch (e) {
        console.log(e); // eslint-disable-line no-console
    }
});

export default bridgeApp;
